import { render, staticRenderFns } from "./ObjectCardRelatedToolbar.vue?vue&type=template&id=62a454fe&scoped=true&"
import script from "./ObjectCardRelatedToolbar.vue?vue&type=script&lang=js&"
export * from "./ObjectCardRelatedToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardRelatedToolbar.vue?vue&type=style&index=0&id=62a454fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a454fe",
  null
  
)

export default component.exports